import React from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { createUUID } from '../../../utils/createUUID';

type IFormProps = {
	children?: React.ReactNode;
	onSubmit: (event: any) => void;
};

export const BaseForm = ({ children, onSubmit }: IFormProps) => {
	return <form onSubmit={onSubmit} className="space-y-5">{children}</form>;
};

type IFormGroupProps = {
	name?: string;
	children?: React.ReactNode;
	label?: string;
	helpBlock?: string;
	className?: string;
	labelSmall?: boolean;
	hasValid?: boolean;
	error?: string;
};

export const FormGroup = (props: IFormGroupProps) => {
	const { label, helpBlock, labelSmall, hasValid, error, children, className } = props;
	const showError = !!error;
	// Use useMemo for uuid so it doesn't bounce on re-renders, or just standard ID logic
	const ui_id = React.useMemo(() => createUUID(), []);
    
	return (
		<div className="space-y-2.5">
			{label && (
				<Label htmlFor={ui_id} className={cn('text-sm font-medium text-foreground', labelSmall && 'text-xs')}>
					{label} {hasValid && <span className='text-destructive'>(*)</span>}
				</Label>
			)}
			<div className={cn("relative", className)}>
				{children}
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
